import { render } from "./BulkUpload.vue?vue&type=template&id=8a56f650&scoped=true"
import script from "./BulkUpload.vue?vue&type=script&lang=js"
export * from "./BulkUpload.vue?vue&type=script&lang=js"

import "./BulkUpload.vue?vue&type=style&index=0&id=8a56f650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a56f650"]])

export default __exports__